export default "__VITE_ASSET__ec020c39__"